export const Strings = {

    VERSION: '3.1.1',

    API_KEY: 'AIzaSyArDLQxXfFgYA7Psf-CpUEnCmxMOUBjbz0',

    MESSAGE_APP_UPDATE: 'Existe una nueva version de la aplicación, presiona el botón de "Aceptar" para actualizarla',
    MESSAGE_APP_INSTALLED: 'Aplicación guardada correctamente',
    MESSAGE_VISIT_NOT_REGISTERED: 'La visita <b>NO FUE REGISTRADA</b>, accede al <b>HISTORIAL</b> para intentar registrarla nuevamente',
    MESSAGE_VISIT_PENDING_TO_REGISTER: 'Visita <b>NO REGISTRADA</b>, por favor presiona el <b>BOTÓN DE ENVIAR</b>',
    MESSAGE_WITHOUT_VISIT_PENDING_TO_REGISTER: 'Actualmente no tienes visitas por registrar',

    ERROR_NEED_LOGIN: 'La sesión ha caducado, por favor ingresa nuevamente al sistema',
    ERROR_PASSWORDS_NOT_MATCH: 'Los passwords no coinciden',
    ERROR_UNEXPECTED: 'Ocurrió un error inesperado, por favor verifica tu conexión e inténtalo nuevamente',
    ERROR_NOT_ALLOWED_IN_CAMERA: 'Para utilizar la cámara es necesario que autorices el permiso solicitado.<br /><br /><b>Nota:</b> Puedes activarlo desde la barra de navegación de forma manual.',
    ERROR_NOT_CAMERAS: 'Tu dispositivo <b>NO TIENE CÁMARAS</b> disponibles.',
    ERROR_UNEXPECTED_IN_CAMERA: 'Ocurrió un error inesperado, por favor inténtalo nuevamente',
    ERROR_NOT_IMAGE: 'El archivo seleccionado debe ser una imagen <b>PNG</b> o <b>JPG</b>',
    ERROR_API_APP: 'Ocurrió un error inesperado, por favor verifica tu conexión e inténtalo nuevamente [ Error: Network Error ]',
    ERROR_LOCATION_FEATURE: 'Tu dispositivo NO cuenta con la capacidad de obtener ubicación actual',
    ERROR_LOCATION: 'Ocurrió un error al obtener tu ubicación actual',
    ERROR_LOCATION_PERMISSION: 'Por favor activa los permisos de ubicación para continuar',
    ERROR_NOT_EVIDENCES: 'Por favor captura por lo menos una <b>UNA EVIDENCIA</b>',
    ERROR_SAVING_VISIT: 'Ocurrió un error inesperado, por favor inténtalo nuevamente'
}
